module.exports = __webpack_public_path__ + "img/img-7.4ab953fa.png";